// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3tuXa","info":"PatientInfo_info__3r84A"};